import React, { useState, useRef, useEffect, useContext } from 'react';
import { Formik, Form } from 'formik';
import { useHistory } from 'react-router';
import * as Yup from 'yup';
import Box from '@material-ui/core/Box';
import { LOGOUT } from 'ConstComponents';
import { ViewBeneficiary as BENE_SELECT } from 'Components/Api/MroaDMTApi';
import { MoneyTransfer as DMT_TRANSFER } from 'Components/Api/MroaDMTApi';
import { useLocation } from 'react-router-dom';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { BalanceContext } from 'Components/BalanceContext';
import {
    Container,
    Grid,
    Paper,
    Button,
    Hidden,
    MenuItem
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { NumberToWord } from 'Components/WordConverter/CustomConverter';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import {
    MESSAGE_CLOSE_AFTER,
    PLEASE_PROVIDE_VALID,
    PLEASE_SELECT_VALID
} from 'Components/Helper/Messages';

import { MaterialCurrency } from 'Components/Inputes/MaterialCurrencyField';
import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';
import { TransactionResponse } from 'Components/Alert/TransactionResponse';
import { MONEY_TRANSFER_CODE } from 'Components/Helper/Messages';
import HOCLoader from 'Components/Loader/HOCLoader';
const CustomContainer = HOCLoader(Container);

export const DMTTransfer = () => {
    const { DashboardBalanceUpdate } = useContext(BalanceContext);
    const classes = commonStyle();
    const history = useHistory();

    const location = useLocation();
    const beneID = location.state.beneID;
    const mobile = location.state.mobile;

    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);

    const [severity, setSeverity] = useState('success');
    const txtUserNameRef = useRef(null);
    const [isResponseAlertOpen, setIsResponseAlertOpen] = useState(false);
    const [ResponseAlert, setResponseAlert] = useState({});
    const [status, setStatus] = useState('PROCESS');
    const [formObject, setFormObject] = useState({
        Mobile: '',
        Name: '',
        BankName: '',
        AccountNo: '',
        IFSC: '',
        Amount: '',
        InWords: '',
        BeneficiaryID: '',
        SenderID: '',
        PaymentType: '0',
        UserRemark: ''
    });

    useEffect(() => {
        select();
        txtUserNameRef.current.focus();
    }, []);

    const select = async () => {
        setLoading(true);

        var requestObj = JSON.stringify({ Mobile: mobile });

        var response = await BENE_SELECT(requestObj);
        setLoading(false);
        if (!response.isAuthorized) {
            LOGOUT();
        }

        if (!response.status) {
            setSeverity('error');
            setLoading(false);
            setIsError(true);
            setResponseMessage(response.data);
            return;
        }

        var data = JSON.parse(response.data);

        data.map(function (item, index) {
            if (item.Mobile === mobile && item.BeneficiaryID === beneID) {
                setFormObject({
                    ...formObject,
                    Mobile: item.Mobile,
                    Name: item.Name,
                    BankName: item.BankName,
                    AccountNo: item.AccountNo,
                    IFSC: item.IFSC,
                    BeneficiaryID: item.BeneficiaryID,
                    SenderID: item.SenderID,
                    Amount: '',
                    InWords: '',
                    PaymentType: '0',
                    UserRemark: ''
                });
            }
        });
    };

    const submithandle = async (values, { setSubmitting, resetForm }) => {
        if (loading) {
            setLoading(false);
            return;
        }

        var requestObj = JSON.stringify(values);

        setLoading(true);
        setIsError(false);

        var response = await DMT_TRANSFER(requestObj);

        if (!response.isAuthorized) {
            LOGOUT();
        }
        DashboardBalanceUpdate();
        setIsError(true);
        setResponseMessage(response.data);
        setSeverity('success');

        if (!response.status) {
            setSeverity('error');
            setLoading(false);
            return;
        }

        var data = JSON.parse(response.data);

        setResponseMessage(data.Message);
        setStatus(data.Status);
        setResponseAlert(data);
        setIsResponseAlertOpen(true);
        setTimeout(() => {
            history.push('/MDMT/Sender/Search/' + values.Mobile);
        }, MESSAGE_CLOSE_AFTER);
    };

    const FormValidationSchema = Yup.object({
        Mobile: Yup.string().required(PLEASE_PROVIDE_VALID + 'mobile'),
        Name: Yup.string().required(PLEASE_PROVIDE_VALID + 'name'),
        BeneficiaryID: Yup.string().required(PLEASE_PROVIDE_VALID + 'name'),
        SenderID: Yup.string().required(PLEASE_PROVIDE_VALID + 'name'),
        BankName: Yup.string().required(PLEASE_PROVIDE_VALID + 'bank'),

        AccountNo: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'account no')
            .min(7, PLEASE_PROVIDE_VALID + 'account no')
            .max(20, PLEASE_PROVIDE_VALID + 'account no'),

        IFSC: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'IFSC')
            .length(11, PLEASE_PROVIDE_VALID + 'IFSC'),

        Amount: Yup.number()
            .required(PLEASE_PROVIDE_VALID + 'amount')
            .min(0, PLEASE_PROVIDE_VALID + 'amount'),

        PaymentType: Yup.string()
            .notOneOf(['0'], PLEASE_SELECT_VALID + 'type')
            .required(PLEASE_SELECT_VALID + 'type')

        // ConfirmAmount: Yup.number()
        //     .required(PLEASE_PROVIDE_VALID + 'confirm amount')
        //     .min(7, PLEASE_PROVIDE_VALID + 'confirm amount')
        //     .max(25000, PLEASE_PROVIDE_VALID + 'confirm amount')
        //     .oneOf([Yup.ref('Amount'), null], "Amount don't match")
    });

    const OnChange = (value, setFieldValue) => {
        if (value === undefined || value <= 0) {
            return;
        }
        setFieldValue('InWords', NumberToWord(value));
    };

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={submithandle}
                resetForm={formObject}
            >
                {({ values, setFieldValue, handleSubmit }) => {
                    return (
                        <Form>
                            <h2 className={classes.PaperHead_h2}>
                                DMT Transfer
                            </h2>
                            <Grid item xs={12}>
                                <Paper className={classes.PaperStyle}>
                                    <Grid container spacing={2}>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="Mobile"
                                                name="Mobile"
                                                type="text"
                                                readOnly={true}
                                                placeholder="Mobile"
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="Bene Name"
                                                name="Name"
                                                type="text"
                                                readOnly={true}
                                                placeholder="Bene Name"
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="Bank"
                                                name="BankName"
                                                type="text"
                                                readOnly={true}
                                                placeholder="Bank"
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="Account No."
                                                name="AccountNo"
                                                type="text"
                                                readOnly={true}
                                                placeholder="Account No."
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="IFSC"
                                                name="IFSC"
                                                type="text"
                                                readOnly={true}
                                                placeholder="IFSC"
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialCurrency
                                                name="Amount"
                                                label="Amount"
                                                placeholder="Amount"
                                                autoComplete="new-password"
                                                inputRef={txtUserNameRef}
                                                max={25000}
                                                onCustomCallback={(value) => {
                                                    OnChange(
                                                        value,
                                                        setFieldValue
                                                    );
                                                }}
                                            />

                                            <Hidden xsUp>
                                                <MaterialTextField
                                                    label="BeneficiaryID"
                                                    name="BeneficiaryID"
                                                    type="text"
                                                    readOnly={true}
                                                    placeholder="BeneficiaryID"
                                                />
                                            </Hidden>

                                            <Hidden xsUp>
                                                <MaterialTextField
                                                    label="SenderID"
                                                    name="SenderID"
                                                    type="text"
                                                    readOnly={true}
                                                    placeholder="SenderID"
                                                />
                                            </Hidden>
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialSelect
                                                label="Type"
                                                name="PaymentType"
                                                title="Select Type"
                                                onCustomCallback={(
                                                    name,
                                                    value
                                                ) => {}}
                                            >
                                                <MenuItem key="0" value="0">
                                                    Select Type
                                                </MenuItem>
                                                <MenuItem
                                                    key="IMPS"
                                                    value="IMPS"
                                                >
                                                    IMPS
                                                </MenuItem>
                                                {/* <MenuItem
                                                    key="NEFT"
                                                    value="NEFT"
                                                >
                                                    NEFT
                                                </MenuItem> */}
                                            </MaterialSelect>
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="Remark"
                                                name="UserRemark"
                                                type="text"
                                                placeholder="Remark"
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="In words"
                                                name="InWords"
                                                type="text"
                                                readOnly={true}
                                                placeholder="InWords"
                                            />
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>

                            <Grid className={classes.footerGrid}>
                                <Box className={classes.flexReverse}>
                                    <div className={classes.SubmitWrapper}>
                                        <Button
                                            type="submit"
                                            title="Transfer"
                                            className={
                                                classes.CustomPrimaryButtonStyle
                                            }
                                            disabled={loading}
                                        >
                                            Transfer
                                        </Button>
                                        {loading && (
                                            <CircularProgress
                                                size={24}
                                                className={
                                                    classes.buttonProgress
                                                }
                                            />
                                        )}
                                    </div>
                                    <Button
                                        type="reset"
                                        title="Reset"
                                        className={
                                            classes.CustomDangerButtonStyle
                                        }
                                    >
                                        Reset
                                    </Button>
                                </Box>
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>
            {isResponseAlertOpen ? (
                <TransactionResponse
                    isOpen={isResponseAlertOpen}
                    title={status}
                    ServiceID={MONEY_TRANSFER_CODE}
                    request={ResponseAlert}
                    OkButtonClick={(request) => {
                        setIsResponseAlertOpen(false);
                    }}
                />
            ) : null}
        </CustomContainer>
    );
};
